<template>
	<div class="wrap">
		<van-nav-bar style="background: #00AC70;" class="custom-nav-bar" title="农事信息" :left-arrow="true"
			@click-left="goBack" />
		<div class="container-box">
			<div class="container-item">
				<div class="top-box">
					<div class="farm-desc">
						<div v-if="farm.remark"><i class="icon fram1"></i>{{ farm.remark || '-' }}</div>
						<div v-if="farm.releaseDate"><i class="icon fram2"></i>发布日期：{{ farm.releaseDate || '-' }}</div>
						<div v-if="farm.shootLocation"><i class="icon farm3"></i>拍摄位置：{{ farm.shootLocation || '-' }}
						</div>
						<div v-if="farm.shootDate"><i class="icon fram2"></i>拍摄日期：{{ farm.shootDate || '-' }}</div>
						<div><i class="icon farm5"></i>天气：{{ farm.weather || '-' }} ·
							温度{{ farm.temperature || '-' }}℃ / 湿度{{ farm.humidity || '-' }}%
						</div>
					</div>
				</div>
				<div v-if="farm.resourceUrl" class="mt20">
					<div v-for="(farmChildItem,farmChildIndex) in filterLists(farm.resourceUrl)" style="margin-bottom:10px;">
						<img :src="farmChildItem.path" alt="" class="fram-wrok" v-if="resourceType(farmChildItem) == 1">
						<div class="video-box" v-if="resourceType(farmChildItem) == 2">
							<img :src="farmChildItem.screenshotPath" alt="" class="poster-img">
							<div class="play-icon" @click="videoPlay(farmChildItem)">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<van-overlay :show="videoShow" @click="closeVideo()" :z-index="1001">
			<div class="mark-video-box" v-if="videoShow">
				<div class="video-title">视频预览</div>
				<div class="close_icon" @click="closeVideo">
					<van-icon name="close" color="#fff" size="24"></van-icon>
				</div>
				<!-- :poster="videoInfo.videoPoster" -->
				<video width="100%" height="80%" style="z-index:100;object-fit: contain;" :src="videoInfo.videoSrc" controls="true"
					play-btn-position="center" autoplay></video>

			</div>
		</van-overlay>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				farm: {

				},
				videoShow: false,
				videoInfo: {
					videoSrc: "",
					videoPoster: ""
				}, //预览的全屏图片
			}
		},
		methods: {
			/**
			 * 返回
			 */
			goBack() {
				sessionStorage.removeItem('shopFarmDetail')
				this.$router.back()
			},
			/**
			 * 获取过滤完的图片
			 */
			filterLists(src) {
				let list = src ? JSON.parse(src) : [];
				return list
			},
			/**
			 * 判断数据类型
			 */
			resourceType(src) {
				if (src.screenshotPath || src.path.includes('.mp4')) {
					return 2
				} else {
					return 1
				}
			},
			/**
			 * 播放视频
			 */
			videoPlay(e) {
				console.log(e, '绑定元素')
				this.videoShow = true;
				this.videoInfo.videoSrc = e.path;
				this.videoInfo.videoPoster = e.screenshotPath;
			},
			/**
			 * 全屏视频关闭
			 */
			closeVideo() {
				this.videoShow = false;
				this.videoInfo.videoSrc = "";
				this.videoInfo.videoPoster = ""
			},
		},
		mounted() {
			window.scrollTo(0,0);
			// this.farm = JSON.parse(JSON.stringify(this.$route.query))
			this.farm = JSON.parse(sessionStorage.getItem('shopFarmDetail'))
			console.log(this.farm, '详情信息')
		}
	}
</script>

<style lang="scss" scoped>
	.wrap {
		background: #FFFFFF;
	}

	.mt20 {
		margin-top: 20px;
	}

	.container-box {
		margin: 30px;
		min-height: 637px;
		border: 1px solid #00AC70;
		padding: 10px;

		.container-item {
			padding: 0 22px 22px 22px;
			border: 1px solid #00AC70;
			min-height: 637px;
			font-size: 26px;
			position: relative;

			.desc {
				padding: 10px 0;
			}

			.company-name {
				font-size: 26px;
				color: #00AC70;
			}

			.user-name,
			.desc-text {
				color: #666666;
			}

			.icon {
				display: inline-block;
				width: 26px;
				height: 26px;
				margin-right: 10px;
				vertical-align: middle;
			}

			.user-icon {
				background: url("../assets/img/userIcon.png") no-repeat;
				background-size: 100% 100%;
			}

			.desc-icon {
				background: url("../assets/img/descIcon.png") no-repeat;
				background-size: 100% 100%;
			}

			img {
				width: 100%;
				height: 100%;
				border-radius: 16px;
				// margin: 20px 0;
			}

			.load-more {
				width: 100%;
				text-align: center;
			}

			.fram-wrok {
				height: 904px;
				background: #00AC70;
				border-radius: 10px;
			}

			.top-box {
				width: 100%;
				// min-height: 260px;
				height: auto;
				border-radius: 10px;

				.farm-desc {
					color: #333333;
					font-size: 26px;

					&>div {
						padding: 15px 0 0;
					}
				}
			}

			.fram1 {
				background: url("../assets/img/icons/farm1.png") no-repeat;
				background-size: 100% 100%;
			}

			.fram2 {
				background: url("../assets/img/icons/farm2.png") no-repeat;
				background-size: 100% 100%;
			}

			.farm3 {
				background: url("../assets/img/icons/farm3.png") no-repeat;
				background-size: 100% 100%;
			}

			.farm5 {
				background: url("../assets/img/icons/farm4.png") no-repeat;
				background-size: 100% 100%;
			}

			.video-item {
				width: 100%;
				height: 1104px;
				object-fit: fill;
			}

			.video-box {
				.play-icon {
					width: 100px !important;
					height: 100px !important;
					background: url(../assets/img/play.png) no-repeat;
					background-size: cover;
					z-index: 1000;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

		.base-container-item {
			img {
				margin: 20px 0;
			}
		}
	}

	.video-box {
		position: relative;
		width: 100%;
		height: 1004px;

		.poster-img {
			width: 100%;
			height: 1004px !important;
			object-fit: fill;
		}
	}

	.mark-video-box {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		.video-title {
			position: absolute;
			top: 30px;
			left: 0;
			width: 100%;
			height: 30px;
			text-align: center;
			line-height: 60 rpx;
			color: #FFFFFF;
			font-size: 24 rpx;
		}

		.close_icon {
			position: absolute;
			right: 20px;
			top: 35px;
		}
	}
</style>
